/**
 * Resolve the Flock server base URL from the runtime origin.
 *   - VITE_FLOCK_SERVER env var always wins.
 *   - In Vite dev mode (any port), default to localhost:3000.
 *   - In production, assume same-origin.
 */
export function flockServerHttpUrl(): string {
  const override = (import.meta.env.VITE_FLOCK_SERVER as string | undefined) ?? '';
  if (override !== '') return override.replace(/\/$/, '');
  if (typeof window === 'undefined') return 'http://localhost:3000';
  if (import.meta.env.DEV) {
    return `${window.location.protocol}//${window.location.hostname}:3000`;
  }
  return `${window.location.protocol}//${window.location.host}`;
}

export function flockServerWsUrl(): string {
  const http = flockServerHttpUrl();
  return http.replace(/^http/, 'ws');
}
